import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { environment } from '../../../environments/environment';

@Injectable()
export class ApagarComunicacaoIndevidaService {
  url: string = environment.BASE_URL;

  constructor(private http: HttpClient) {}

  apagarComunicacaoIndevida(protocolo: number): Observable<any> {
    return this.http
      .delete(`${this.url}/apagarComunicacaoIndevida/${protocolo}`)
      .map((data) => data);
  }
}
